module.exports = __webpack_public_path__ + "img/btn_arrows.47ffa95c.png";